import Person2OutlinedIcon from "@mui/icons-material/Person2Outlined"
import StarBorderOutlinedIcon from "@mui/icons-material/StarBorderOutlined"
import HelpOutlineIcon from "@mui/icons-material/HelpOutline"

export const menus = [
  {
    name: "my_account",
    icon: Person2OutlinedIcon,
    path: "/account",
  },
  {
    name: "favorite",
    icon: StarBorderOutlinedIcon,
    path: "/favorite",
  },
  {
    name: "faq",
    icon: HelpOutlineIcon,
    path: "/faq",
  },
  // {
  //   name: "about",
  //   icon: NoteOutlinedIcon,
  //   path: "/diver",
  // },
]

export const langMenus = [
  {
    name: "en-US",
    translation: "en",
  },
  {
    name: "ja-JP",
    translation: "ja",
  },
]
